module.exports = __webpack_public_path__ + "banquet/components/AccountSettings/images/email_toggle_highlight.3ad6bdeeace9f5c0063ed371f99116b8.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/AccountSettings/images/email_toggle_highlight.svg
// module id = 1642
// module chunks = 1